import React from 'react';
import { injectIntl } from '../../util/reactIntl';
import RequestInvoicingModal from './RequestInvoicingModal';
import { createCurrentUser } from '../../util/test-data';

// The modal needs the intl object as a prop, so wrap it for the styleguide.
const OpenRequestInvoicingModal = injectIntl(props => (
  <RequestInvoicingModal
    isOpen
    onClose={() => null}
    onManageDisableScrolling={() => null}
    onLookupCompany={() => Promise.resolve({ company: null, revenue: null })}
    onSubmit={() => Promise.resolve({ status: 'pending' })}
    onSaveBillingDetails={() => Promise.resolve()}
    {...props}
  />
));

// A complete business billing profile: opens straight on the request step.
const businessUser = createCurrentUser('u2', {
  email: 'matti@testi.fi',
  profile: {
    firstName: 'Matti',
    lastName: 'Meikäläinen',
    displayName: 'Matti M',
    abbreviatedName: 'MM',
    privateData: {
      billing: {
        customerType: 'BUSINESS',
        legalName: 'Testi Oy',
        country: 'FI',
        postalCode: '00100',
        street: 'Testikatu 1',
        city: 'Helsinki',
        vatNumber: 'FI31503663',
        businessProofRef: null,
      },
    },
  },
});

// A consumer billing profile: opens on the billing step with the company
// option preselected, since invoicing is for companies only.
const consumerUser = createCurrentUser('u1', {
  email: 'matti@testi.fi',
  profile: {
    firstName: 'Matti',
    lastName: 'Meikäläinen',
    displayName: 'Matti M',
    abbreviatedName: 'MM',
    privateData: { billing: { customerType: 'CONSUMER', country: 'FI', postalCode: '00100' } },
  },
});

// Finland, nothing looked up yet.
export const Initial = {
  component: OpenRequestInvoicingModal,
  props: {
    currentUser: businessUser,
    lookupInProgress: false,
    lookupResult: null,
    lookupError: null,
    submitInProgress: false,
    submitError: null,
    result: null,
  },
  group: 'transaction',
};

// Missing or non-business billing profile: the billing step runs first.
export const BillingStep = {
  ...Initial,
  props: {
    ...Initial.props,
    currentUser: consumerUser,
  },
};

// A previously approved invoicing request, shown instead of the form.
export const Approved = {
  component: OpenRequestInvoicingModal,
  props: {
    currentUser: businessUser,
    result: {
      status: 'approved',
      company: {
        name: 'Testi Oy',
        businessId: '3150366-3',
        companyForm: 'Osakeyhtiö',
        address: { street: 'Testikatu 1', postalCode: '00100', city: 'Helsinki', country: 'FI' },
      },
      revenue: { amount: 2500000, currency: 'EUR' },
    },
  },
  group: 'transaction',
};

// The automatic check failed: the customer is sent back to pay by card.
export const Denied = {
  ...Approved,
  props: {
    ...Approved.props,
    result: {
      ...Approved.props.result,
      status: 'denied',
      revenue: { amount: 850000, currency: 'EUR' },
    },
  },
};

// A company outside Clevenio's coverage: ops reviews the request by hand.
export const Pending = {
  ...Approved,
  props: {
    ...Approved.props,
    result: { status: 'pending', company: null, revenue: null },
  },
};
